import { create } from 'zustand';

/**
 * Qual botão de ação está aberto no editor. A prévia o mostra sempre, fora da janela de
 * tempo, para o usuário ver o que está editando.
 */
interface ActionButtonEditorState {
  openButtonId: string | null;
  setOpenButtonId: (id: string | null) => void;
}

export const useActionButtonEditorStore = create<ActionButtonEditorState>((set) => ({
  openButtonId: null,
  setOpenButtonId: (id) => set({ openButtonId: id }),
}));
